











import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class Exp extends Vue {
  @Prop() private exp!: object[];
  @Prop() private isPassExp: boolean;
  // 获取登录信息
  get userInfo() {
    return this.$store.state.userInfo;
  }
  //跳转搜索页面
  private toSearchTask(row) {
    let path = row.path;
    window.open(path, '_blank');
  }
  // 任务星星按照从少到多排序 并取前三位
  get taskExp() {
   const list = this.exp;
    list.forEach((item, index) => {
      if(this.expNum[(item as any).id]){
        (item as any).myExp=this.expNum[(item as any).id]
      }else{
        (item as any).myExp=0;
      }
      let expName = (item as any).title;
      let category_id = (item as any).id;
      let path = `/task/search?expName=可以获取【${expName}】经验值的任务&category_id=${category_id}`;
      (item as any).path = path;
    });
    list.sort((a, b) => {
      return (a as any).value - (b as any).value;
    });
    const resList = this.exp.slice(0, 3);
    return resList;
  }
  // 获取我的经验值 {typeID:nums}
  get expNum() {
    let experience = this.$store.state.myExp;
    let obj = {};
    experience.forEach((item, idx) => {
      obj[item.category_id] = item.experience;
    });
    return obj;
  }
  // 是否满足
  get satisfy() {
    let flag = true;
    // this.taskExp.forEach((item, index) => {
    //   flag =
    //     flag &&
    //     ((item as any).value <= this.expNum[(item as any).id] ? true : false);
    // });
    flag =this.isPassExp;
    return flag;
  }
  private columns: object[] = [
    {
      title: '类型',
      key: 'title',
      slot: 'title',
      width: '60',
    },
    {
      title: `准入`,
      key: 'value',
      width: '38',
      align: 'center',
    },
    {
      title: `我的经验值`,
      key: 'myExp',
       width: '46',
      align: 'center',
    },
    {
      title: `做题正确`,
      key: 'add_value',
       width: '38',
       slot: 'add_value',
      align: 'center',
    },
    {
      title: `做题错误`,
      key: 'fail_value',
       width: '38',
       slot: 'fail_value',
      align: 'center',
    }
  ];
}
